class ApiResponse {
  data = null
  errors = null
  isSessionExpired = false
  token = null

  constructor (httpResponse) {
    if (httpResponse) {
      if (httpResponse.isSuccessStatusCode) {
        // Http request success.
        // Check for errors since old mywellness cloud services return 200 even if response has errors.
        if (httpResponse.body.errors) {
          this.errors = httpResponse.body.errors
          this.checkValidToken()
        } else {
          this.data = httpResponse.body.data
        }

        this.setToken(httpResponse)
      } else {
        // Http request error.
        this.errors = [this.getGenericError()]
      }
    }
  }

  checkValidToken () {
    for (var i = 0; i < this.errors.length; i++) {
      if (
        this.errors[i].type === 'Security' &&
        (this.errors[i].field === 'TokenNotValid' || this.errors[i].details === 'TokenNotValid')
      ) {
        this.isSessionExpired = true
        break
      }
    }
  }

  setToken (httpResponse) {
    this.setTokenByAuthorizationHeader(httpResponse)
    if (!this.token) {
      this.setByBodyToken(httpResponse)
    }
  }

  setTokenByAuthorizationHeader (httpResponse) {
    if (httpResponse.headers.authorization) {
      let token = httpResponse.headers.authorization.split(' ')
      if (token && token.length > 1) {
        this.token = token[1]
      }
    }
  }

  setByBodyToken (httpResponse) {
    if (httpResponse.body.token && httpResponse.body.token !== null) {
      this.token = httpResponse.body.token
    }
  }

  hasErrors () {
    return this.errors !== null && this.errors.length > 0
  }

  getErrorMessage () {
    let message = ''

    if (this.hasErrors()) {
      // Get the message of the first error.
      if (this.errors[0].errorMessage) {
        message = this.errors[0].errorMessage
      } else if (this.errors[0].details) {
        message = this.errors[0].details
      }
    }
    return message
  }

  getGenericError () {
    return {
      field: 'Exception',
      type: 'System',
      details: 'An error occurred.',
      message: 'An error occurred.',
      errorMessage: 'An error occurred.'
    }
  }
}

export default ApiResponse
